// ResetSenha.js
import React, { useState, useEffect } from 'react';
import api from '../api';
import { useAuth } from '../auth';

export default function ResetSenha() {
  const { token } = useAuth();
  const [clientes, setClientes] = useState([]);
  const [usuarioSelecionado, setUsuarioSelecionado] = useState('');
  const [novaSenha, setNovaSenha] = useState('');
  const [mensagem, setMensagem] = useState('');

  useEffect(() => {
    fetchClientes();
  }, [token]);

  const fetchClientes = async () => {
    try {
      const response = await api.get('/api/clientes');
      setClientes(response.data || []);
      setMensagem('');
    } catch (error) {
      console.error('Erro ao buscar os clientes:', error);
      if (error.response?.status === 401) {
        setMensagem('Token expirado. Faça login novamente.');
      } else {
        setMensagem('Erro ao buscar clientes. Tente novamente mais tarde.');
      }
    }
  };

  const handleResetSenha = async () => {
    if (!usuarioSelecionado) {
      setMensagem('Selecione um usuário para resetar a senha.');
      return;
    }

    if (!novaSenha) {
      setMensagem('Informe a nova senha.');
      return;
    }

    if (novaSenha.length < 6) {
      setMensagem('A senha deve ter no mínimo 6 caracteres.');
      return;
    }

    if (!window.confirm('Tem certeza que deseja resetar a senha deste usuário?')) {
      return;
    }

    try {
      const response = await api.put(
        `/api/clientes/reset-senha/${usuarioSelecionado}`,
        { novaSenha }
      );
      setMensagem(response.data.message || 'Senha resetada com sucesso!');
      setNovaSenha('');
    } catch (error) {
      console.error('Erro ao resetar a senha:', error);
      setMensagem(
        error.response?.data?.message ||
          'Erro ao resetar a senha. Tente novamente mais tarde.'
      );
    }
  };

  return (
    <div className="reset-senha-container">
      <h2>Resetar Senha de Usuário</h2>
      <select
        value={usuarioSelecionado}
        onChange={(e) => setUsuarioSelecionado(e.target.value)}
      >
        <option value="">Selecione um usuário</option>
        {clientes.map((cliente) => (
          <option key={cliente.id} value={cliente.id}>
            {cliente.id} - {cliente.nome} ({cliente.email})
          </option>
        ))}
      </select>
      <p></p>
      <input
        type="password"
        placeholder="Nova Senha"
        value={novaSenha}
        onChange={(e) => setNovaSenha(e.target.value)}
      />
      <button onClick={handleResetSenha}>Resetar Senha</button>
      {mensagem && <p>{mensagem}</p>}
    </div>
  );
}
